import { FC } from 'react';

import { Flex, Group, Stack, Text } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';

import { selectPersonId, selectReplacedPersonId } from '@/store/user-process/user-selectors';

import { Avatar } from '@/entities/Avatar';

import { getUserName } from '@/shared/helpers/utils';
import useAppStore from '@/shared/store/app.store';
import { AutorizationResponseType } from '@/shared/types/app.types';

import { useAppSelector } from '@/hooks';

type TUserCardProps = {
	detail?: boolean;
	onClick?: () => void;
};

export const UserCard: FC<TUserCardProps> = ({ detail = false, onClick }) => {
	const [user] = useLocalStorage<AutorizationResponseType>({ key: 'user' });
	const isMobile = useAppStore((state) => state.isMobile);

	const personId = useAppSelector(selectPersonId);
	const replacedPersonId = useAppSelector(selectReplacedPersonId);

	if (isMobile)
		return (
			<Flex align="center" onClick={onClick}>
				<Group>
					<Avatar size="lg" fullName={getUserName(user?.user.full_name, 'full')} />
					<Stack gap={0}>
						<Text size="lg" fw={700} unselectable="on">
							{getUserName(user?.user.full_name, 'full')}
						</Text>
						<Text c="dimmed" size="md" fw={500} unselectable="on">
							{getUserName(user?.user.email, 'full')}
						</Text>
					</Stack>
				</Group>
			</Flex>
		);

	return (
		<Flex align="center" justify="space-between">
			{detail ? (
				<Stack gap={0}>
					<Text size="lg" fw={700} unselectable="on">
						{getUserName(user?.user.full_name, 'full')}
					</Text>
					<Text c="dimmed" size="md" fw={500} unselectable="on">
						{getUserName(user?.user.email, 'full')}
					</Text>
				</Stack>
			) : (
				<Stack gap={0} pr={12}>
					<Text size="lg" fw={700} ta={'right'} unselectable="on">
						{getUserName(user?.user.full_name, 'first')}
					</Text>
					{personId !== replacedPersonId && (
						<Text c="red" size="sm" ta={'right'} fw={500} unselectable="on">
							Пользователь замещён
						</Text>
					)}
				</Stack>
			)}

			<Avatar fullName={getUserName(user?.user.full_name, 'full')} />
		</Flex>
	);
};
